function walkNodes(payload, nodeTypes, callback) {
  // Iterate over all nodes in payload and invoke callback with the node
  let allNodes = [];
  allNodes = allNodes.concat(payload.leafNodes);
  for (const group of payload.groups) {
    allNodes = allNodes.concat(group.children);
  }

  for (const node of allNodes) {
    if (!node) {
      continue;
    }
    if (node.name === 'Action') {
      const action = node.data.action;
      if (action && nodeTypes.includes(action.type)) {
        callback(action);
      }
    } else if (node.name === 'Check') {
      for (const check of Object.values(node.data)) {
        if (nodeTypes.includes(check.type)) {
          callback(check);
        }
      }
    } else if (node.name === 'Effect') {
      const effect = node.data.effect;
      if (effect && nodeTypes.includes(effect.type)) {
        callback(effect);
      }
    }
  }
}

export default walkNodes;